// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2zDwy","large":"styles_large__1R-bm"};